module.exports = __webpack_public_path__ + "img/delete-confirm.3614af78.svg";